import { useParams } from 'react-router-dom';
import { useState, React, useEffect, useContext } from 'react';
import _noop from 'lodash-es/noop';
import Button from 'sushiweb/Button';
import PropTypes from 'prop-types';
import Layout from 'sushiweb/Layout';
import red from 'sushiweb/tokens/color/red';
import { P } from 'sushiweb/Typography';
import MenuItem from 'sushiweb/MenuItem';

import Card from '../../../../../common/components/Card';
import { reviewAddProgramToGroup } from '../../../../../../api/VoucherProgram';
import { FormCacheContext } from '../../../../../WalletPrograms/CreateProgramModal/ProgramForms/common/Components/FormTemplate/FormTemplate';
import VoucherProgram from '../../../../../WalletPrograms/CreateProgramModal/ProgramForms/VoucherProgramForm/Steps/VoucherProgram';
import { genericErrorMsg } from '../../../../../../constants';
import {
  InputWrapper,
  StyledDropdown,
} from '../../../../../WalletPrograms/styles';
import {
  applicableFlowTypes,
  currentFlowTypeEnum,
  programStatusEnum,
} from '../../../../../common/components/constants';
import { getCycleAmount } from '../../../../../../helpers';

const SelectPlan = ({
  currentFlow,
  selectedWorkspace,
  // fetchingWorkspaces,
  // fetchedWorkspaces,
  groupDetails,
  programsData,
  getAllPrograms,
  fetchedPrograms,
  fetchingPrograms,
  fetchingProgramInfo,
  fetchedProgramInfo,
  programInfo,
  getProgramInfo,
  showErrorToast,
  getAllQuestions,
}) => {
  const {
    bodyStyle,
    footerStyle,
    goToNextStep,
    updateCachedFormData,
    stepsVisibility,
    getCachedFormData,
  } = useContext(FormCacheContext);
  const [plan, setPlan] = useState('');
  const [planList, setPlanList] = useState([]);
  const [planInfo, setPlanInfo] = useState({});
  const { id = ' ' } = useParams();
  const [flag, setFlag] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const {
    checkedPlan: cachedPlan = '',
    planDetails: cachedFlag,
  } = getCachedFormData();

  useEffect(() => {
    setPlan(cachedPlan);
    setFlag(cachedFlag);
    getAllPrograms({
      workspaceId: selectedWorkspace?.workspace_id,
      flowType: currentFlow,
    });
    getAllQuestions();
    stepsVisibility(false);
  }, []);

  useEffect(() => {
    if (!fetchingPrograms && fetchedPrograms) {
      const { programs = [] } = programsData;
      const activePrograms = [];
      programs.forEach(prog => {
        if (prog.program_status !== programStatusEnum.DELETED) {
          activePrograms.push(prog);
        }
      });
      setPlanList(activePrograms);
    }
  }, [fetchingPrograms]);

  useEffect(() => {
    if (!fetchingProgramInfo && fetchedProgramInfo) {
      setPlanInfo(programInfo);
      if (plan !== '') {
        setFlag(true);
      }
    }
  }, [fetchingProgramInfo]);

  const handlePlanChange = val => {
    setPlan(val);
    setFlag(false);
    const programId = val?.program_id;
    const workspaceId = selectedWorkspace?.workspace_id;
    getProgramInfo({ programId, companyId: id, workspaceId });
  };

  const handleNextBtnClick = () => {
    setCreateLoading(true);
    const body = {
      workspace_id: selectedWorkspace?.workspace_id,
      program_id: plan?.program_id,
      group_id: groupDetails?.group_id,
      current_cycle: false,
    };
    reviewAddProgramToGroup(body)
      .then(res => {
        setCreateLoading(false);
        if (!res.status) {
          showErrorToast(genericErrorMsg);
          return;
        }
        updateCachedFormData({
          checkedPlan: plan,
          planDetails: flag,
          reviewAddProgram: res,
          workspace_id: selectedWorkspace?.workspace_id,
        });
        goToNextStep();
      })
      .catch(err => {
        setCreateLoading(false);
        console.error(err);
        showErrorToast(genericErrorMsg);
      });
  };

  const renderPlanDetails = () => {
    return <VoucherProgram planData={planInfo} planDataFlag={flag} />;
  };

  return (
    <>
      <Card.Body style={{ ...bodyStyle, minHeight: '120px' }}>
        <Layout>
          <Layout.Item colD={12} colT={12} colM={12}>
            <InputWrapper>
              <P>
                <span className='required-field'>Choose Plan</span>
              </P>
              <StyledDropdown
                width='100%'
                value={plan?.name}
                label='Plan'
                onSelect={handlePlanChange}
                borderColor={red.z500}
              >
                {planList.map(item => {
                  return (
                    <MenuItem
                      value={item}
                      label={`${item.name} - ${getCycleAmount(item)}`}
                    />
                  );
                })}
              </StyledDropdown>
              <br />
            </InputWrapper>
          </Layout.Item>
        </Layout>
        {flag && renderPlanDetails()}
      </Card.Body>
      <Card.Footer style={footerStyle}>
        <InputWrapper>
          <Button
            align='right'
            onClick={handleNextBtnClick}
            loading={createLoading}
            disabled={!flag}
          >
            Continue
          </Button>
        </InputWrapper>
      </Card.Footer>
    </>
  );
};

SelectPlan.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  groupDetails: PropTypes.objectOf(PropTypes.any),
  programsData: PropTypes.objectOf(PropTypes.any),
  fetchedPrograms: PropTypes.bool,
  fetchingPrograms: PropTypes.bool,
  getAllPrograms: PropTypes.func,
  programInfo: PropTypes.objectOf(PropTypes.any),
  getProgramInfo: PropTypes.func,
  fetchingProgramInfo: PropTypes.bool,
  fetchedProgramInfo: PropTypes.bool,
  showErrorToast: PropTypes.func,
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  getAllQuestions: PropTypes.func,
  // fetchedWorkspaces: PropTypes.bool,
  // fetchingWorkspaces: PropTypes.bool,
};

SelectPlan.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  groupDetails: {},
  programsData: {},
  fetchedPrograms: false,
  fetchingPrograms: false,
  getAllPrograms: _noop,
  programInfo: {},
  getProgramInfo: _noop,
  fetchedProgramInfo: true,
  fetchingProgramInfo: true,
  showErrorToast: _noop,
  selectedWorkspace: {},
  getAllQuestions: _noop,
  // fetchedWorkspaces: true,
  // fetchingWorkspaces: true,
};

export default SelectPlan;
